import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";

import { server } from "../../../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../../../store/stateFunctions";
import useQuickLook from "../../../quicklook/useQuickLook";

const initialValues = {
  title: "",
  links: "",
  registration_fees: "",
  description: "",
  event_date: "",
  category: "",
  address: "",
  location: "",
  time: "",
  image: null,
};

const swalalert = withReactContent(Swal);

const AddIndustryEvents = ({ role }) => {
  const user = useSelectAccess("Industry User");
  const displayFile = useQuickLook();
  const [show, setShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.setValues(initialValues);
    setShow(true);
  };

  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const handleShowGallery = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
    if (isEditMode && selectedData) {
      formik.setValues({
        title: selectedData.title,
        registration_fees: selectedData.registration_fees,
        description: selectedData.description,
        category: selectedData.category,
        event_date: selectedData.event_date,
        address: selectedData.address,
        location: selectedData.location,
        time: selectedData.time,
        links: selectedData.links,
        image: selectedData.image,
      });
    }
  }, [isEditMode, selectedData]);

  // Get Gallery
  const getData = () => {
    server
      .get("/event/getevent", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete gallery
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/event/deleteind_event/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Event has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update news
  const handleUpdate = (values) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("registration_fees", values.registration_fees);
    formData.append("description", values.description);
    formData.append("category", values.category);
    formData.append("time", values.time);
    formData.append("address", values.address);
    formData.append("event_date", values.event_date);
    formData.append("location", values.location);
    formData.append("links", values.links);

    if (values.image) {
      formData.append("image", values.image);
    }

    server
      .put(`/event/updateind_event/${values.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        formik.resetForm();
        getData();
        toast.success("Event Updated successfully");
        handleClose();
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Add
  const formik = useFormik({
    initialValues: isEditMode ? selectedData : initialValues,
    validationSchema: Yup.object({
      title: Yup.string().required("Enter a Event title"),
      links: Yup.string().required("Enter a Event Links"),
      registration_fees: Yup.string().required(
        "Enter a Event Registration Fees"
      ),
      description: Yup.string().required("Enter a Event Description"),
      category: Yup.string().required("Enter a Event Category"),
      time: Yup.string().required("Enter a Event Timing"),
      address: Yup.string().required("Enter a Event Address"),
      event_date: Yup.string().required("Enter a Event date"),
      location: Yup.string().required("Enter a Event Location"),
      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (isEditMode) {
        handleUpdate({ ...values, id: selectedData.id });
      } else {
        if (!values.image) {
          toast.error("Please select a images");
          return;
        }
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("registration_fees", values.registration_fees);
        formData.append("description", values.description);
        formData.append("category", values.category);
        formData.append("time", values.time);
        formData.append("address", values.address);
        formData.append("event_date", values.event_date);
        formData.append("location", values.location);
        formData.append("image", values.image);
        formData.append("links", values.links);

        server
          .post("/event/addind_event", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              toast.success("Event Added successfully");
              formik.resetForm();
              handleClose();
              getData();
            }
          })
          .catch(function (error) {
            if (error.response?.data?.message)
              toast.error(error.response.data.message);
            else if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else toast.error("Failed to connect to server");
          });
      }
    },
  });

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/event/searchevents?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/event/filter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <div className="container">
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              className="form-control"
              placeholder="Search Event"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Last 2 days
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
            </select>
          </div>
        </div>
        <div className="d-flex title-relative mb-3 justify-content-center ">
          <h5 className="m-auto text-center">Previous Events</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Add Events
          </Button>

          <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode ? "Edit Event Details" : "Add Event Details"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="title"
                        margin="dense"
                        type="text"
                        placeholder="Title"
                        variant="outlined"
                        label="Event Title"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.title ? (
                        <p className="text-danger">{formik.errors.title}</p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="description"
                        margin="dense"
                        type="text"
                        placeholder="Description"
                        variant="outlined"
                        label="Event Description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.description ? (
                        <p className="text-danger">
                          {formik.errors.description}
                        </p>
                      ) : null}
                    </div>

                    <div className="form-outline mb-2">
                      <TextField
                        name="time"
                        margin="dense"
                        type="text"
                        placeholder="Time"
                        variant="outlined"
                        label="Time"
                        value={formik.values.time}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.time ? (
                        <p className="text-danger">{formik.errors.time}</p>
                      ) : null}
                    </div>

                    <div className="form-group mb-2">
                      <TextField
                        name="event_date"
                        margin="dense"
                        type="date"
                        variant="outlined"
                        label="Event Date"
                        value={formik.values.event_date}
                        onChange={formik.handleChange}
                        InputProps={{
                          inputProps: {
                            min: new Date().toISOString().substring(0, 10),
                          },
                        }}
                        fullWidth
                        required
                        style={{ margin: "8px 0" }}
                        InputLabelProps={{ shrink: true }}
                      ></TextField>
                      {formik.errors.event_date ? (
                        <p className="text-danger mb-0">
                          {formik.errors.event_date}
                        </p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="links"
                        margin="dense"
                        type="text"
                        placeholder="Registration links"
                        variant="outlined"
                        label="Registration links"
                        value={formik.values.links}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.links ? (
                        <p className="text-danger">{formik.errors.links}</p>
                      ) : null}
                    </div>
                  </Col>

                  <Col>
                    <div className="form-outline mb-2">
                      <div className="form-outline mb-2">
                        <TextField
                          name="registration_fees"
                          margin="dense"
                          type="text"
                          placeholder="Registration Fees"
                          variant="outlined"
                          label="Registration Fees"
                          value={formik.values.registration_fees}
                          onChange={formik.handleChange}
                          fullWidth
                          required
                        ></TextField>
                        {formik.errors.registration_fees ? (
                          <p className="text-danger">
                            {formik.errors.registration_fees}
                          </p>
                        ) : null}
                      </div>
                      <TextField
                        name="address"
                        margin="dense"
                        type="text"
                        placeholder="Address"
                        variant="outlined"
                        label="Address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.address ? (
                        <p className="text-danger">{formik.errors.address}</p>
                      ) : null}
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="location"
                        margin="dense"
                        type="text"
                        placeholder="location"
                        variant="outlined"
                        label="Location"
                        value={formik.values.location}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.location ? (
                        <p className="text-danger">{formik.errors.location}</p>
                      ) : null}
                    </div>
                    <div className="mb-2">
                      <FormControl fullWidth required className="mt-2">
                        <InputLabel id="demo-simple-select-label">
                          Category
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Year"
                          variant="outlined"
                          name="category"
                          value={formik.values.category}
                          onChange={formik.handleChange}
                          required
                        >
                          <MenuItem value="city">City Event</MenuItem>
                          <MenuItem value="industry">Industry Event</MenuItem>
                          <MenuItem value="institute">Institute Event</MenuItem>
                          <MenuItem value="university">
                            University Event
                          </MenuItem>
                        </Select>
                        {formik.errors.category ? (
                          <p className="text-danger mb-0">
                            {formik.errors.category}
                          </p>
                        ) : null}
                      </FormControl>
                    </div>
                    <div className="form-outline mb-2">
                      <TextField
                        name="image"
                        margin="dense"
                        type="file"
                        variant="outlined"
                        label="Event Images"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <label htmlFor="image">Upload Image</label>
                            </InputAdornment>
                          ),
                          inputProps: {
                            accept: ".jpg, .png, .jpeg",
                            onChange: (event) => {
                              formik.setFieldValue(
                                "image",
                                event.currentTarget.files[0]
                              );
                            },
                          },
                        }}
                      />
                      {formik.errors.image ? (
                        <p className="text-danger">{formik.errors.image}</p>
                      ) : null}
                    </div>
                  </Col>
                </Row>

                <div className="pt-1 mb-2 ">
                  <Button variant="contained" type="submit">
                    {isEditMode ? "Update" : "Post"}
                  </Button>
                  <Button
                    className="float-end"
                    variant="contained"
                    color="warning"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>

        <div className="container" style={{ overflowX: "scroll" }}>
          <table className="table table-striped border">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th> Event Title</th>
                <th>Description</th>
                <th>Category</th>
                <th>Date</th>
                <th>Time</th>
                <th>Address</th>
                <th>Location</th>
                <th>Images</th>
                <th>Status</th>
                <th>Update</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.map((item, index) => {
                  return (
                    <tr key={item.id}>
                      <th scope="row">{index + 1}</th>
                      <td>{item.title}</td>
                      <td>{item.description}</td>
                      <td>{item.category}</td>
                      <td>{item.event_date}</td>
                      <td>{item.time}</td>
                      <td>{item.address}</td>
                      <td>{item.location}</td>
                      <td>
                        <a href={item.image} target="_blank">
                          <img
                            width="50"
                            height="50"
                            src={item.image}
                            // alt={item.file}
                          />
                        </a>
                      </td>
                      <td>{item.status}</td>
                      <td>
                        <div className="btn banner text-white">
                          <AiFillEdit onClick={() => handleShowGallery(item)} />
                        </div>
                      </td>
                      <td>
                        <div className="btn banner text-white">
                          <AiFillDelete onClick={() => handleDelete(item)} />
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AddIndustryEvents;
